export default __webpack_public_path__ + "static/media/sampleHandlebarsMjml.827bab6b.svg";